export default function (str: string) {
  const isLangKeyRegex = /^[a-z]+(\.[a-z0-9-_]+)+$/i

  return isLangKeyRegex.test(str)
}
